import { helpers, tp } from '@marketplace/plugins/global.js'
import { localeToI18nLocale } from '@shared/config/lang.js'
import Vue from 'vue'

/**
 * Add the legacy helpers and mixins.
 *
 * @param {object} context
 * @param {object} context.store
 * @param context.$i18n
 * @param context.i18n
 * @param {Function}  inject
 */
export default function ({ store, i18n }, inject) {
    inject('helpers', helpers)

    inject('locale', i18n.locale)
    inject('localeCode', localeToI18nLocale(i18n.locale))

    inject('tp', tp)
    Vue.prototype.tp = tp
}
